import { requestSlots, selectDate } from '@r1-frontend/service-engineer-visit/actions';
import DateSelection from '@r1-frontend/service-engineer-visit/components/DateSelection';
import { useContextDispatch, useContextSelector } from '@r1-frontend/service-engineer-visit/hooks';
import getSlots from '@r1-frontend/service-engineer-visit/selectors/getSlots';
import moreSlotsButtonIsDisabled from '@r1-frontend/service-engineer-visit/selectors/moreSlotsButtonIsDisabled';
import { TGetTimeSlots } from '@r1-frontend/service-engineer-visit/types/TGetTimeSlots';

type TDateSelectionContainerProps = {
    sendAnalytics: ({ action, label }: { action: string, label?: string }) => void,
    getTimeSlotsFunc: TGetTimeSlots,
    productId?: number,
    gaLabel?: string,
}

const DateSelectionContainer = ({ sendAnalytics, getTimeSlotsFunc, productId, gaLabel }: TDateSelectionContainerProps): JSX.Element => {
    const { slots, moreButtonIsDisabled, selectedDate, requestedDays } = useContextSelector(state => ({
        slots: getSlots(state),
        moreButtonIsDisabled: moreSlotsButtonIsDisabled(state),
        selectedDate: state.selected.date,
        requestedDays: state._requestedDays,
    }));
    const dispatch = useContextDispatch();

    const handleSelectDate = (date: string) => () => {
        dispatch(selectDate(date));
        sendAnalytics({
            action: 'choosed_date',
            label: gaLabel,
        });
    };

    const handleMore = () => {
        dispatch(requestSlots(productId, getTimeSlotsFunc, gaLabel));
    };

    return (
        <DateSelection
            slots={slots}
            selectedDate={selectedDate}
            handleSelectDate={handleSelectDate}
            handleMore={handleMore}
            requestedDays={requestedDays}
            moreButtonIsDisabled={moreButtonIsDisabled}
        />
    );
};

export default DateSelectionContainer;
